export default __webpack_public_path__ + "static/how-5c9096dddb82d73689c65c5cb0a86fd0.svg";